<template>
  <b-card
      no-body
      border-variant="secondary"
      :header="$t('title.report.country_details_total')"
      header-bg-variant="primary"
      header-text-variant="white"
      align="left"
  >
    <table v-if="!isBusy && countryDetailsTotal" class="table table-striped mb-0">
      <tbody>
      <tr>
        <td class="font-weight-bolder">{{ $t('table.report.country_details_total.all_deposits') }}</td>
        <td>{{ countryDetailsTotal.allDeposits }}</td>
      </tr>
      <tr>
        <td class="font-weight-bolder">{{ $t('table.report.country_details_total.confirmed_accounts') }}</td>
        <td>{{ countryDetailsTotal.confirmedAccounts }}</td>
      </tr>
      <tr>
        <td class="font-weight-bolder">{{ $t('table.report.country_details_total.date_total') }}</td>
        <td>{{ countryDetailsTotal.date }}</td>
      </tr>
      <tr>
        <td class="font-weight-bolder">{{ $t('table.report.country_details_total.first_deposit') }}</td>
        <td>{{ countryDetailsTotal.firstDeposit }}</td>
      </tr>
      <tr>
        <td class="font-weight-bolder">{{ $t('table.report.country_details_total.registrations') }}</td>
        <td>{{ countryDetailsTotal.registrations }}</td>
      </tr>
      </tbody>
    </table>
    <div class="spinner-wrapper" v-else-if="isBusy">
      <b-spinner></b-spinner>
    </div>
  </b-card>
</template>

<script>
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState({
      isBusy: (state) => state.reports.isBusy,
      countryDetailsTotal: (state) => state.reports.countryDetails.total
    })
  }
}
</script>
